import { render, staticRenderFns } from "./closeCase.vue?vue&type=template&id=08d62650&scoped=true"
import script from "./closeCase.vue?vue&type=script&lang=js"
export * from "./closeCase.vue?vue&type=script&lang=js"
import style0 from "./closeCase.vue?vue&type=style&index=0&id=08d62650&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d62650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d62650')) {
      api.createRecord('08d62650', component.options)
    } else {
      api.reload('08d62650', component.options)
    }
    module.hot.accept("./closeCase.vue?vue&type=template&id=08d62650&scoped=true", function () {
      api.rerender('08d62650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/closeCase.vue"
export default component.exports